var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.emailSignupFormCustomInputEmailV1 = {
    attach: function (context) {}
  };
})(jQuery);
